:host {
    display: block;
    --progress-height: 3px;
    --track-bg: rgba(0, 0, 0, 0.06);
    --bar-color: #3b82f6;
    /* Color por defecto de la barra */
    --bar-width: 40%;
    --animation-duration: 1.6s;
}

.track {
    position: relative;
    height: var(--progress-height);
    background: var(--track-bg);
    border-radius: 999px;
    overflow: hidden;
}

.bar {
    position: absolute;
    top: 0;
    left: -50%;
    height: 100%;
    width: var(--bar-width);
    background: linear-gradient(90deg, var(--bar-color), rgba(255, 255, 255, 0.15));
    transform: translateX(0);
    animation: slide var(--animation-duration) cubic-bezier(.2, .8, .2, 1) infinite;
}

.bar--2 {
    animation-delay: calc(var(--animation-duration) / 2);
    opacity: 0.85;
}

:host([paused]) .bar {
    animation-play-state: paused;
}

@keyframes slide {
    0% {
        left: -50%;
    }

    100% {
        left: 120%;
    }
}